"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
// Styles
const Styled = __importStar(require("./Styled"));
function Loading({ color, fullScreen, margin, size, testId }) {
    return ((0, jsx_runtime_1.jsx)(Styled.Wrapper, Object.assign({ fullScreen: fullScreen }, { children: (0, jsx_runtime_1.jsx)(Styled.Loading, { "data-testid": `${testId}-Loading`, css: {
                width: size || '50px',
                height: size || '50px',
                minWidth: size || '50px',
                minHeight: size || '50px',
                margin: `${margin || '0px'} auto`,
                borderTop: `6px solid ${color || '$actionableDefault'}`,
            } }) })));
}
exports.Loading = Loading;
